<script>
  export let label;
  export let playing;
</script>

<button class:playing class="play" aria-label={label} on:click>
  <span class="icon" />
</button>

<style>
  .play {
    border: none;
    position: relative;
    background-color: var(--color-accent);
    color: white;

    height: var(--button-height);
    width: 100%;
    min-width: var(--button-width);
    max-width: var(--button-width);

    border-radius: 50%;
    opacity: 1;
    transition: opacity 150ms ease;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon {
    display: block;
    background: var(--color-accent-text);
    clip-path: polygon(0 0, 100% 50%, 0 100%);
    height: 30%;
    width: 30%;
    transform: translate(10%, 0);
  }

  .play::after {
    box-sizing: border-box;
    content: "";
    display: block;
    background: transparent;
    border-radius: 50%;
    position: absolute;
    top: calc(-0.5 * var(--play-btn-extra));
    left: calc(-0.5 * var(--play-btn-extra));
    height: calc(100% + var(--play-btn-extra));
    width: calc(100% + var(--play-btn-extra));
    border: 2px dashed red;

    opacity: 0;
    transition: opacity 150ms ease;
  }

  .play:focus,
  .play:hover {
    opacity: 0.8;
  }
  /* PLAY BUTTON PLAYING STATE */
  .play.playing {
    animation: pulse 3s linear alternate infinite;
  }

  .play.playing .icon {
    clip-path: none;
    transform: none;
  }

  .play.playing::after {
    opacity: 1;
    animation: spin 10s linear infinite;
  }

  /* END PLAY BUTTON PLAYING STATE */
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes pulse {
    100% {
      background-color: var(--color-accent-faded);
    }

    0% {
      background-color: var(--color-accent);
    }
  }
</style>
